// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Cn from "../../../../node_modules/rescript-classnames/lib/es6_global/src/Cn.bs.js";
import * as Curry from "../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Caml_obj from "../../../../node_modules/rescript/lib/es6/caml_obj.js";
import * as ReactIf from "react-if";
import * as Belt_Array from "../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Caml_option from "../../../../node_modules/rescript/lib/es6/caml_option.js";
import * as CSS$Showside from "../utils/CSS.bs.js";
import * as Card$Showside from "./Card.bs.js";
import * as UseSafeTimeout from "../../../../node_modules/@makerinc/use-safe-timeout/lib/es6_global/src/UseSafeTimeout.bs.js";
import * as NavSDK$Showside from "../utils/NavSDK.bs.js";
import * as PDPForm$Showside from "./PDPForm.bs.js";
import * as Product$Showside from "../types/Product.bs.js";
import * as SmartImg$Showside from "../utils/SmartImg.bs.js";
import * as Favorites$Showside from "./Favorites.bs.js";
import * as IconCartAdd$Showside from "../icons/IconCartAdd.bs.js";
import * as Prioritize2$Showside from "../utils/Prioritize2.bs.js";
import * as UseQuantity$Showside from "../hook/UseQuantity.bs.js";
import * as CategoryCard$Showside from "./CategoryCard.bs.js";
import * as MobileNavbar$Showside from "./MobileNavbar.bs.js";
import * as ProductPrice$Showside from "./ProductPrice.bs.js";
import * as ProductBadges$Showside from "./ProductBadges.bs.js";
import * as PullDownModal$Showside from "./PullDownModal.bs.js";
import * as StoreProvider$Showside from "../context/StoreProvider.bs.js";
import * as ProductReviews$Showside from "./ProductReviews.bs.js";
import * as RouterProvider$Showside from "../context/RouterProvider.bs.js";
import * as ProductSwatches$Showside from "./ProductSwatches.bs.js";
import * as ViewportContext$Showside from "../context/ViewportContext.bs.js";
import * as ConditionalRender$Showside from "../utils/ConditionalRender.bs.js";
import * as EntrypointContext$Showside from "../context/EntrypointContext.bs.js";
import * as ProductRulesConfig$Showside from "../types/ProductRulesConfig.bs.js";
import * as UseDisplayVariantBy$Showside from "../hook/UseDisplayVariantBy.bs.js";
import * as ProductCardCTAButton$Showside from "./ProductCardCTAButton.bs.js";
import * as ConfigurationProvider$Showside from "../context/ConfigurationProvider.bs.js";
import * as PDPContentDetailsCard$Showside from "./PDPContentDetailsCard.bs.js";
import * as ProductCardHoverImage$Showside from "./ProductCardHoverImage.bs.js";
import * as ProductDetailsContext$Showside from "../context/ProductDetailsContext.bs.js";
import * as GridDensityZoomProvider$Showside from "../context/GridDensityZoomProvider.bs.js";
function ProductCard$Default(Props) {
  var shape = Props.shape;
  var productCategory = Props.productCategory;
  var product = Props.product;
  var productPriceStyle = Props.productPriceStyle;
  var activeVariantId = Props.activeVariantId;
  var enableAddToCartOpt = Props.enableAddToCart;
  var highlightActiveVariantOpt = Props.highlightActiveVariant;
  var onClick = Props.onClick;
  var onAddToCartOpt = Props.onAddToCart;
  var onImageRendered = Props.onImageRendered;
  var fluidOpt = Props.fluid;
  var removeAllInfoOpt = Props.removeAllInfo;
  var onOpenLink = Props.onOpenLink;
  var isMiniPDPVisible = Props.isMiniPDPVisible;
  var dataCount = Props.dataCount;
  var enableAddToCart = enableAddToCartOpt !== undefined ? enableAddToCartOpt : true;
  var highlightActiveVariant = highlightActiveVariantOpt !== undefined ? highlightActiveVariantOpt : true;
  var onAddToCart = onAddToCartOpt !== undefined ? onAddToCartOpt : function (param, param$1, param$2, param$3) {};
  var fluid = fluidOpt !== undefined ? fluidOpt : false;
  var removeAllInfo = removeAllInfoOpt !== undefined ? removeAllInfoOpt : false;
  var store = StoreProvider$Showside.use(undefined);
  var ref = React.useRef(null);
  var match = EntrypointContext$Showside.use(undefined);
  var displayVariantBy = UseDisplayVariantBy$Showside.useDisplayVariantBy(undefined);
  var match$1 = ConfigurationProvider$Showside.use(undefined);
  var match$2 = match$1.config;
  var transitiveAccount = match$2.transitiveAccount;
  var settings = match$2.settings;
  var match$3 = RouterProvider$Showside.useRouter(undefined);
  var goTo = match$3.goTo;
  var route = match$3.route;
  var match$4 = GridDensityZoomProvider$Showside.use(undefined);
  var isZoomEnabled = match$4.isZoomEnabled;
  var gridColumns = match$4.gridColumns;
  var match$5 = ViewportContext$Showside.use(undefined);
  var isMobile = match$5.isMobile;
  var hideMediaFromOtherVariants = Belt_Option.mapWithDefault(transitiveAccount, false, function (account) {
    return account.pdpHideMediaFromOtherVariants;
  });
  var hideOutOfStock = settings.hideOutOfStock;
  var getInitialVariant = function (param) {
    return Product$Showside.getInitialDisplayVariant(hideOutOfStock, activeVariantId, displayVariantBy, product);
  };
  var match$6 = React.useState(function () {
    return getInitialVariant(undefined);
  });
  var setSelectedVariant = match$6[1];
  var selectedVariant = match$6[0];
  var match$7 = React.useState(function () {
    return false;
  });
  var setIsHovered = match$7[1];
  var isHovered = match$7[0];
  var overrideAddToCartLabel = Belt_Option.flatMap(Belt_Option.flatMap(transitiveAccount, function (account) {
    return account.productRules.customAddToCartText;
  }), function (data) {
    if (ProductRulesConfig$Showside.matchesProduct(data.rule, product, selectedVariant)) {
      return data;
    }
  });
  var disableWhenOutOfStock = Belt_Option.mapWithDefault(overrideAddToCartLabel, true, function (data) {
    return !data.overrideOutOfStock;
  });
  var overrideAddToCartLabel$1 = Belt_Option.map(overrideAddToCartLabel, function (data) {
    return data.text;
  });
  var hideAddToCartButton = Belt_Option.mapWithDefault(Belt_Option.flatMap(transitiveAccount, function (account) {
    return account.productRules.hideAddToCartButton;
  }), false, function (rule) {
    return ProductRulesConfig$Showside.matchesProduct(rule, product, selectedVariant);
  });
  var enableAddToCart$1 = !hideAddToCartButton && enableAddToCart;
  React.useEffect(function () {
    Curry._1(setSelectedVariant, function (param) {
      return getInitialVariant(undefined);
    });
  }, [activeVariantId]);
  var match$8 = Belt_Option.getWithDefault(shape, settings.productCardShape);
  var shape$1 = typeof match$8 === "number" && (match$8 > 3 || match$8 < 1) ? settings.productCardShape : shape;
  var match$9 = Product$Showside.getDisplayProductCardMedia(hideMediaFromOtherVariants, product, selectedVariant);
  var firstMedia = match$9[0];
  var secondMedia = Belt_Array.get(match$9[1], 0);
  var firstMediaSize = Product$Showside.Media.getImageSize(firstMedia);
  var firstImageUrl = Product$Showside.Media.getImageUrlWithPosterFallback(firstMedia);
  var secondImageUrl = Belt_Option.flatMap(secondMedia, Product$Showside.Media.getImageUrlWithPosterFallback);
  var firstVideoUrl = Product$Showside.Media.getVideoUrl(firstMedia);
  var secondVideoUrl = Belt_Option.flatMap(secondMedia, Product$Showside.Media.getVideoUrl);
  var videoUrl = firstVideoUrl !== undefined ? firstVideoUrl : secondVideoUrl !== undefined ? secondVideoUrl : undefined;
  var renderCardVideo = function (fallbackImageUrl, videoUrl) {
    var tmp = {
      videoUrl: videoUrl,
      settings: settings,
      showIndicator: false,
      controlsClassName: CSS$Showside.prefix("z-20 bottom-14"),
      parentRef: ref,
      alt: product.name,
      fitToContainer: settings.productCardFitToContainer
    };
    if (fallbackImageUrl !== undefined) {
      tmp.imageUrl = Caml_option.valFromOption(fallbackImageUrl);
    }
    if (onImageRendered !== undefined) {
      tmp.onImageRendered = Caml_option.valFromOption(onImageRendered);
    }
    return React.createElement(CategoryCard$Showside.CardVideo.make, tmp);
  };
  var onHover = React.useCallback(function (param) {
    Curry._1(setIsHovered, function (param) {
      return true;
    });
  }, [setIsHovered]);
  var isProductSelected;
  if (typeof route === "number") {
    isProductSelected = false;
  } else {
    switch (route.TAG | 0) {
      case /* PDP */2:
        isProductSelected = route._0.productId === product.id && highlightActiveVariant;
        break;
      case /* QuickView */3:
        isProductSelected = Caml_obj.equal(route._0.productId, product.id) && highlightActiveVariant;
        break;
      default:
        isProductSelected = false;
    }
  }
  var onMouseLeave = React.useCallback(function (param) {
    Curry._1(setIsHovered, function (param) {
      return false;
    });
    Curry._1(setSelectedVariant, function (param) {
      return getInitialVariant(undefined);
    });
  }, [setIsHovered]);
  var match$10 = React.useState(function () {
    return /* Unmount */3;
  });
  var setShowMiniPDP = match$10[1];
  var showMiniPDP = match$10[0];
  var match$11 = UseSafeTimeout.useSafeTimeout(undefined, undefined);
  var setMiniPDPTimeout = match$11.setTimeout;
  var removeOverlay = React.useMemo(function () {
    if (typeof route === "number" || !(route.TAG === /* ListPage */1 && isZoomEnabled && !isMobile)) {
      return false;
    } else {
      return gridColumns >= /* TwelveColumnGrid */8;
    }
  }, [route, isZoomEnabled, gridColumns, match$5.breakpoint, isMobile]);
  var renderAddToCartButton = function (selectedVariant) {
    var onClickAddToCartMobile = function (param) {
      Curry._1(setShowMiniPDP, function (param) {
        return /* Render */0;
      });
      if (isMiniPDPVisible !== undefined) {
        isMiniPDPVisible.current = true;
      }
      if (typeof route !== "number" && route.TAG === /* QuickView */3) {
        var match = route._0;
        var productId = match.productId;
        Curry._3(goTo, undefined, undefined, {
          TAG: /* QuickView */3,
          _0: {
            mediaId: match.mediaId,
            mediaParentId: match.mediaParentId,
            albumId: undefined,
            productId: productId,
            relatedMediaProductIds: match.relatedMediaProductIds,
            relatedMediaCategoryId: match.relatedMediaCategoryId,
            variantId: match.variantId,
            panelClosed: productId === undefined ? false : match.panelClosed,
            zoomedPhotoIndex: match.zoomedPhotoIndex,
            time: match.time
          }
        });
      }
      setMiniPDPTimeout(function (param) {
        Curry._1(setShowMiniPDP, function (param) {
          return /* Show */1;
        });
      }, 42);
    };
    var renderAddToCartMobile = function (param) {
      return React.createElement(ProductCardCTAButton$Showside.make, {
        size: /* Sm */0,
        icon: React.createElement(IconCartAdd$Showside.make, {
          size: 22
        }),
        style: {
          backgroundColor: settings.pdpCTAButtonBgColor,
          color: settings.pdpCTAButtonTextColor
        },
        onClick: onClickAddToCartMobile,
        disabled: false,
        primary: true,
        preventDefault: true,
        outline: true,
        labelDataTestId: "add-to-cart-label",
        dataTestId: "product-card-add-to-cart"
      });
    };
    var renderAddToCartDesktop = function (param) {
      return React.createElement(PDPForm$Showside.AddToCartButton.make, {
        show: isHovered,
        product: product,
        variant: selectedVariant,
        category: productCategory,
        label: Belt_Option.getWithDefault(overrideAddToCartLabel$1, settings.pdpAddToCartLabel),
        disableWhenOutOfStock: disableWhenOutOfStock,
        disabledLabel: settings.outOfStockLabel,
        confirmationLabel: Belt_Option.getWithDefault(overrideAddToCartLabel$1, settings.pdpAddToCartConfirmation),
        children: React.createElement(ProductCardCTAButton$Showside.make, {
          size: /* Sm */0,
          style: {
            backgroundColor: settings.pdpCTAButtonBgColor,
            color: settings.pdpCTAButtonTextColor
          },
          primary: true,
          preventDefault: true,
          outline: true,
          wrapText: true,
          labelDataTestId: "add-to-cart-label",
          dataTestId: "product-card-add-to-cart"
        }),
        onAddToCart: onAddToCart
      });
    };
    return React.createElement(ConditionalRender$Showside.When.make, {
      condition: settings.productCardAddToCart && firstImageUrl !== undefined && enableAddToCart$1,
      children: React.createElement("div", {
        className: CSS$Showside.prefix(Cn.make(["absolute p-3 bottom-0 transform transition-all duration-150", isMobile ? "w-auto right-0" : "w-full left-0", isMobile ? "opacity-100 translate-y-0" : "opacity-0 translate-y-2", isMobile ? "" : "max-h-full overflow-auto no-scrollbar", "group-2-hover:opacity-100 group-2-hover:translate-y-0", "focus-within-visible:opacity-100 focus-within-visible:translate-y-0", "group-2-focus-visible:opacity-100 group-2-focus-visible:translate-y-0"]))
      }, isMobile ? renderAddToCartMobile(undefined) : renderAddToCartDesktop(undefined))
    });
  };
  var renderReviews = Belt_Option.getWithDefault(Belt_Option.map(product.reviewSummary, function (summary, param) {
    return React.createElement(ProductReviews$Showside.Summary.make, {
      at: /* PLP */1,
      summary: summary,
      className: CSS$Showside.prefix("mt-2")
    });
  }), function (param) {
    return null;
  });
  var renderBadges = function (param) {
    return React.createElement(ProductBadges$Showside.make, {
      className: CSS$Showside.prefix("pt-2 -mb-1"),
      dataTestId: "plp-product-badges",
      size: /* Sm */1,
      product: product,
      variant: selectedVariant
    });
  };
  var renderFavoritesButton = function (param) {
    return React.createElement(Favorites$Showside.ToggleButton.make, {
      product: product,
      tabIndex: 0
    });
  };
  var prioritizedRender = function (priority) {
    var renderOverlay = function (param) {
      return React.createElement(React.Fragment, undefined, isMobile || removeAllInfo ? null : renderFavoritesButton(undefined), renderAddToCartButton(selectedVariant));
    };
    var tmp;
    if (videoUrl !== undefined) {
      tmp = renderCardVideo(firstImageUrl, videoUrl);
    } else {
      var tmp$1 = {
        src: Belt_Option.getWithDefault(firstImageUrl, ""),
        fit: settings.productCardFitToContainer ? /* Contain */2 : /* Cover */1,
        alt: product.name,
        priority: priority
      };
      if (onImageRendered !== undefined) {
        tmp$1.onRender = Caml_option.valFromOption(onImageRendered);
      }
      var tmp$2 = {
        src: Belt_Option.getWithDefault(secondImageUrl, ""),
        fit: settings.productCardFitToContainer ? /* Contain */2 : /* Cover */1,
        alt: product.name,
        priority: priority + 1 | 0,
        enabled: !isMobile && secondImageUrl !== undefined && selectedVariant.id === getInitialVariant(undefined).id
      };
      if (onImageRendered !== undefined) {
        tmp$2.onImageRendered = Caml_option.valFromOption(onImageRendered);
      }
      tmp = React.createElement(React.Fragment, undefined, React.createElement(SmartImg$Showside.make, tmp$1), React.createElement(ProductCardHoverImage$Showside.make, tmp$2));
    }
    var tmp$3 = {
      fluid: fluid,
      id: selectedVariant.id,
      preventLinkDefault: true,
      lineClamp: settings.productCardTitleLineTruncate,
      showTitle: !removeAllInfo,
      selected: isProductSelected,
      title: Product$Showside.getDisplayName(store, selectedVariant, product),
      contentBoxStylableClassName: "product-card__content-box",
      titleStylableClassName: "product-card__title",
      imageSize: firstMediaSize,
      fwdRef: ref,
      dataTestId: "product-card-test-id",
      titleDataTestId: "product-card-title",
      renderTitle: function (title) {
        if (isMobile) {
          return React.createElement("div", {
            className: CSS$Showside.prefix("flex")
          }, React.createElement("div", {
            className: CSS$Showside.prefix("flex-grow flex flex-col overflow-hidden")
          }, renderBadges(undefined), title), React.createElement("div", {
            className: CSS$Showside.prefix("flex-shrink-0")
          }, renderFavoritesButton(undefined)));
        } else {
          return React.createElement("div", {
            className: CSS$Showside.prefix("flex flex-col")
          }, renderBadges(undefined), title);
        }
      },
      children: tmp,
      renderAfterTitle: function (param) {
        if (removeAllInfo) {
          return;
        }
        var tmp = {
          at: /* PLP */1,
          product: product,
          variant: selectedVariant,
          priceBlockStylableClassName: "product-card__price-box",
          priceStylableClassName: "product-card__price",
          salePriceStylableClassName: "product-card__sale-price"
        };
        if (productPriceStyle !== undefined) {
          tmp.style = Caml_option.valFromOption(productPriceStyle);
        }
        return Caml_option.some(React.createElement("div", {
          className: CSS$Showside.prefix("pb-6")
        }, React.createElement(ReactIf.If, {
          condition: isMobile,
          children: null
        }, React.createElement(ReactIf.Then, {
          children: React.createElement(ProductSwatches$Showside.Minimal.make, {
            hideOutOfStock: hideOutOfStock,
            product: product
          })
        }), React.createElement(ReactIf.Else, {
          children: React.createElement(ProductSwatches$Showside.Large.make, {
            selectedVariant: selectedVariant,
            product: product,
            onChange: function (variant) {
              Curry._1(setSelectedVariant, function (param) {
                return variant;
              });
            }
          })
        })), React.createElement(PDPForm$Showside.make, PDPForm$Showside.makeProps(product, selectedVariant, undefined, settings.hideOutOfStock, undefined, undefined, React.createElement(ProductPrice$Showside.make, tmp), undefined, undefined)), Curry._1(renderReviews, undefined)));
      },
      renderOverlay: removeAllInfo || removeOverlay ? function (param) {
        return null;
      } : renderOverlay,
      onClickLink: function (param) {
        if (settings.openProductLink) {
          return Curry._5(onOpenLink, productCategory, dataCount, product, selectedVariant, undefined);
        } else {
          return Curry._2(onClick, product, selectedVariant);
        }
      },
      onHover: onHover,
      onMouseLeave: onMouseLeave
    };
    if (shape$1 !== undefined) {
      tmp$3.shape = Caml_option.valFromOption(shape$1);
    }
    var tmp$4 = Belt_Option.map(selectedVariant.link, function (url) {
      return {
        TAG: /* URL */0,
        _0: url
      };
    });
    if (tmp$4 !== undefined) {
      tmp$3.link = Caml_option.valFromOption(tmp$4);
    }
    if (dataCount !== undefined) {
      tmp$3.dataCount = dataCount;
    }
    return React.createElement(Card$Showside.make, tmp$3);
  };
  var scrollToDetailsRef = React.useRef(function (param) {});
  var match$12 = React.useState(function () {
    return selectedVariant;
  });
  var setMiniPDPSelectedVariant = match$12[1];
  var miniPDPSelectedVariant = match$12[0];
  var handleCloseMiniPDP = function (param) {
    Curry._1(setShowMiniPDP, function (param) {
      return /* Hide */2;
    });
    if (isMiniPDPVisible !== undefined) {
      isMiniPDPVisible.current = false;
    }
    setMiniPDPTimeout(function (param) {
      Curry._1(setShowMiniPDP, function (param) {
        return /* Unmount */3;
      });
    }, 500);
  };
  var match$13 = UseQuantity$Showside.useQuantity(undefined, product, selectedVariant);
  var quantity = match$13[0];
  var handleFormChange = function (product, nextVariant) {
    Curry._1(setMiniPDPSelectedVariant, function (previous) {
      return Belt_Option.getWithDefault(nextVariant, previous);
    });
  };
  var handleFormSubmit = function (submission) {
    var submissionResult;
    submissionResult = submission.TAG === /* Ok */0 ? submission._0 : undefined;
    var quantity$1 = Belt_Option.getWithDefault(quantity, 1);
    if (submissionResult === undefined) {
      return Promise.resolve(undefined);
    }
    var match = submissionResult.submitButtonType;
    if (typeof match === "number") {
      if (match !== 0) {
        Curry._5(onOpenLink, productCategory, dataCount, submissionResult.product, submissionResult.variant, undefined);
        return Promise.resolve(undefined);
      } else {
        handleCloseMiniPDP(undefined);
        Curry._4(onAddToCart, submissionResult.product, submissionResult.variant, quantity$1, productCategory);
        return new Promise(function (resolve, reject) {
          setTimeout(function (param) {
            resolve(settings.pdpAddToCartConfirmation);
          }, 1000);
        });
      }
    }
    var confirmation = match.confirmation;
    Curry._3(match.run, submissionResult.product, submissionResult.variant, quantity$1);
    if (confirmation !== undefined) {
      return new Promise(function (resolve, reject) {
        setTimeout(function (param) {
          resolve(confirmation);
        }, 1000);
      });
    } else {
      return Promise.resolve(undefined);
    }
  };
  var tmp;
  if (showMiniPDP >= 3) {
    tmp = null;
  } else {
    var tmp$1 = {
      product: product,
      variant: miniPDPSelectedVariant,
      shouldForceMobile: true,
      scrollToDetailsRef: scrollToDetailsRef,
      quantity: quantity,
      setQuantity: match$13[1],
      stickyCTA: false,
      sections: ["promo", "summary", "variants", "quantity", "cta"],
      showSecondaryCTA: false,
      showTertiaryCTA: false,
      showFavoriteButton: Caml_obj.notequal(match$3.listPageType, /* Favorites */0),
      showCustomColors: false
    };
    if (productCategory !== undefined) {
      tmp$1.productCategory = Caml_option.valFromOption(productCategory);
    }
    tmp = React.createElement(PullDownModal$Showside.make, {
      children: React.createElement("div", {
        className: CSS$Showside.prefix("w-screen")
      }, React.createElement(PDPForm$Showside.make, PDPForm$Showside.makeProps(product, miniPDPSelectedVariant, undefined, settings.hideOutOfStock, handleFormChange, handleFormSubmit, React.createElement(PDPContentDetailsCard$Showside.make, tmp$1), undefined, undefined)), match.embedType !== 4 ? React.createElement(MobileNavbar$Showside.make, {
        position: /* Relative */2,
        initiator: "product-card",
        itemsAlign: "items-center",
        onClick: function (param) {
          handleCloseMiniPDP(undefined);
        }
      }) : React.createElement("div", {
        className: CSS$Showside.prefix("h-8")
      })),
      isOpen: showMiniPDP === /* Show */1,
      onClose: handleCloseMiniPDP,
      showHeader: false,
      unmount: false,
      pullDownTarget: "modal",
      dataId: product.id,
      dataTestId: "product-card-add-to-cart-prompt"
    });
  }
  return React.createElement(ProductDetailsContext$Showside.Provider.make, {
    product: product,
    variant: miniPDPSelectedVariant,
    children: null
  }, React.createElement(Prioritize2$Showside.make, {
    render: prioritizedRender
  }), tmp);
}
ProductCard$Default.displayName = "ProductCard.Default";
var Default = {
  make: ProductCard$Default
};
function ProductCard(Props) {
  var shape = Props.shape;
  var productCategory = Props.productCategory;
  var product = Props.product;
  var productPriceStyle = Props.productPriceStyle;
  var activeVariantId = Props.activeVariantId;
  var enableAddToCartOpt = Props.enableAddToCart;
  var highlightActiveVariantOpt = Props.highlightActiveVariant;
  var onClick = Props.onClick;
  var onAddToCartOpt = Props.onAddToCart;
  var onImageRendered = Props.onImageRendered;
  var fluidOpt = Props.fluid;
  var removeAllInfoOpt = Props.removeAllInfo;
  var onOpenLink = Props.onOpenLink;
  var isMiniPDPVisible = Props.isMiniPDPVisible;
  var dataCount = Props.dataCount;
  var enableAddToCart = enableAddToCartOpt !== undefined ? enableAddToCartOpt : true;
  var highlightActiveVariant = highlightActiveVariantOpt !== undefined ? highlightActiveVariantOpt : true;
  var onAddToCart = onAddToCartOpt !== undefined ? onAddToCartOpt : function (param, param$1, param$2, param$3) {};
  var fluid = fluidOpt !== undefined ? fluidOpt : false;
  var removeAllInfo = removeAllInfoOpt !== undefined ? removeAllInfoOpt : false;
  var match = ConfigurationProvider$Showside.use(undefined);
  var renderFallback = function (param) {
    var tmp = {
      product: product,
      enableAddToCart: enableAddToCart,
      highlightActiveVariant: highlightActiveVariant,
      onClick: onClick,
      onAddToCart: onAddToCart,
      fluid: fluid,
      removeAllInfo: removeAllInfo,
      onOpenLink: onOpenLink
    };
    if (shape !== undefined) {
      tmp.shape = Caml_option.valFromOption(shape);
    }
    if (productCategory !== undefined) {
      tmp.productCategory = Caml_option.valFromOption(productCategory);
    }
    if (productPriceStyle !== undefined) {
      tmp.productPriceStyle = Caml_option.valFromOption(productPriceStyle);
    }
    if (activeVariantId !== undefined) {
      tmp.activeVariantId = activeVariantId;
    }
    if (onImageRendered !== undefined) {
      tmp.onImageRendered = Caml_option.valFromOption(onImageRendered);
    }
    if (isMiniPDPVisible !== undefined) {
      tmp.isMiniPDPVisible = Caml_option.valFromOption(isMiniPDPVisible);
    }
    if (dataCount !== undefined) {
      tmp.dataCount = dataCount;
    }
    return React.createElement(ProductCard$Default, tmp);
  };
  var match$1 = match.config.settings.productCardComponent;
  if (match$1 === undefined) {
    return renderFallback(undefined);
  }
  var tmp = {
    componentId: match$1.id,
    data: product,
    props: match$1.props,
    renderFallback: renderFallback
  };
  if (activeVariantId !== undefined) {
    tmp.activeVariantId = activeVariantId;
  }
  return React.createElement(NavSDK$Showside.ProductRenderer.make, tmp);
}
ProductCard.displayName = "ProductCard";
var make = React.memo(ProductCard);
export { Default, make };
/* make Not a pure module */